import styled from 'styled-components'
import { Swiper as SwiperReact } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'
import { IcChevronLeft, IcChevronRight } from '../../Icons'
import theme from '../../theme/ota'

export interface SwiperProps {
  $paginationBottom?: string
}

export const Swiper = styled(SwiperReact)<SwiperProps>`
  height: 100%;
  cursor: pointer;

  &:hover {
    .swiper-button-prev,
    .swiper-button-next {
      opacity: 0.7;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    background-color: ${({ theme }) => theme.colors?.textColor};
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 30px;
    opacity: 0;
    position: absolute;
    top: 45%;
    transition: ease-in-out 0.3s;
    width: 30px;
    z-index: 2;

    &::after {
      background-color: ${({ theme }) => theme.colors?.textColor};
      content: '';
    }
  }

  .swiper-button-prev {
    background-image: url(${IcChevronLeft});
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-button-next {
    background-image: url(${IcChevronRight});
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: 10px;
  }

  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: 10px;
  }

  .swiper-button-disabled {
    opacity: 0 !important;
    transition: ease-in-out 0.3s;
  }

  .swiper-slide {
    width: 100% !important;
  }

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    background: ${theme.colors.white};
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    width: 32px;
    height: 8px;
    transition: width 0.5s;
    border-radius: 4px;
    background: ${theme.colors.white};
  }

  .swiper-pagination-bullets {
    bottom: ${({ $paginationBottom }) => $paginationBottom || '10px'} !important;
  }
`
